import React, { useEffect, useState } from "react";

import MDButton from "components/MDButton";

import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Box,
  Paper,
  Button,
  ButtonGroup,
  Typography,
  Stack,
} from "@mui/material";

import TransactionHistory from "./TransactionHistoryModule/TransactionHistory";

import GuestDetailsIndex from "./GuestDetails";

import CheckOut from "./GuestCheckoutModule/CheckOut";

import "./GuestPopUp.css";

import { useNavigate } from "react-router-dom";

import EditGuestPopUp from "./EditGuestPopUp";

import { Image, Row, Col, Container } from "react-bootstrap";

import axios from "../../../../Uri";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import MDTypography from "components/MDTypography";

import ForceCheckout from "./GuestCheckoutModule/ForceCheckout";

export default function GuestPopUp({
  open,

  handleCloseGuestModalWindow,

  ...props
}) {
  let userData = JSON.parse(sessionStorage.getItem("userdata"));

  const [showEditGuest, setShowEditGuest] = useState(false);

  const [type, setType] = useState("");

  const [guestPicUrl, setGuestPicUrl] = React.useState({});

  const [openDlg2Dialog, setDialog2Open] = React.useState(false);

  const UploadPhoto = (event) => {
    if (event.target.files[0].size >= 1000000) {
      toast.warning("Please select file with less than 1 MB");
    } else {
      if (event.target.files[0] !== null) {
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("fileName", event.target.files[0].name);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };

        axios

          .post(`/guest/upload/${props.GuestDetails.id}/`, formData, config)

          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              toast.success("Guest picture uploaded successfully");
            }
          })

          .catch((error) => {
            toast.error("Not Uploaded");
          });
      }
    }
  };

  const editForceCheckout = () => {
    setType("forcecheck");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

  const editGuestHandler = () => {
    handleCloseGuestModalWindow();
    setType("editGuest");
    setShowEditGuest(!showEditGuest);
  };

  const editBedtHandler = () => {
    setType("bed");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };
const preBooking =()=>{
  setType("preebooking");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

  const exceedPlan = () => {
    setType("exceedDue");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

  const editDue = () => {
    setType("editDue");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

  const cancelCheckOut = () => {
    setType("cancelCheckout");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

    const extendPlanforRegulatAndMonthlyAsDaily = () => {
    setType("extendPlanforRegulatAndMonthlyAsDaily");

    handleCloseGuestModalWindow();

    setShowEditGuest(!showEditGuest);
  };

  

  const func = () => {
    setDialog2Open(true);
  };

  useEffect(async () => {
    await axios
      .get(`/guest/files/${props.GuestDetails.id}`)
      .then((res) => {
        setGuestPicUrl(res.data);
      })

      .catch((err) => {
        console.log(err);
      });
  }, [props.GuestDetails.id]);

  return (
    <div>
      <EditGuestPopUp
        type={type}
        guestdetails={props.GuestDetails}
        showEditGuest={showEditGuest}
        editGuestHandler={editGuestHandler}
        handleCloseGuestModalWindow={handleCloseGuestModalWindow}
      />

      <ForceCheckout
        open={openDlg2Dialog}
        close={() => setDialog2Open(false)}
        opens={open}
        editForceCheckout={editForceCheckout}
        handleCloseGuestModalWindow={handleCloseGuestModalWindow}
        setType={setType}
        type={type}
        guestdetails={props.GuestDetails}
      />

      <Dialog open={open} onClose={handleCloseGuestModalWindow} maxWidth="lg">
        <MDButton
          width="20%"
          variant="contained"
          color="info"
          size="large"
          justify="center"
          style={{ borderRadius: 0 }}
        >
          Guest Details
        </MDButton>

        <DialogContent>
          <Grid>
            <Grid
              container
              xs={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              marginBottom="12px"
            >
              <Image
                className="pic"
                alt={`${props.GuestDetails.firstName}`}
                src={`data:image/jpeg;base64,${guestPicUrl.data}`}
                height={230}
                width={200}
              />
            </Grid>

            <ToastContainer
              position="top-right"
              min-width="2%"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Grid>

          <GuestDetailsIndex
            guestdetails={props.GuestDetails}
            GuestDueAmount={props.GuestDueAmount}
            TotalAmountByGuest={props.TotalAmountByGuest}
          />

          <br />

          <Grid item xs={12}>
            <MDTypography gutterBottom>
              <h4 className="head-1-checkOut">Guest Actions</h4>
            </MDTypography>
          </Grid>

          {props.GuestDetails.guestStatus == "VACATED" ? (
            <></>
          ) : (
            <Grid lg={12} md={12} xs={12}>
              <Paper sx={{ mt: 2, height: "60px" }}>
                <Stack
                  spacing={2}
                  direction="row"
                  mt={2}
                  mb={2}
                  ml={2}
                  justifyContent="center"
                >
                  {userData.data.userType !== "manager" ? (
                    <Button
                      sx={{ mt: 1, "&.MuiButton-text": { color: "white" } }}
                      color="primary"
                      size="medium"
                      justify="center"
                      component="label"
                    >
                      change Photo
                      <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={UploadPhoto}
                      />
                    </Button>
                  ) : (
                    <br />
                  )}
                  {userData.data.userType !== "manager" ? (
                    <Button
                      sx={{ mt: 7, "&.MuiButton-text": { color: "purple" } }}
                      color="white"
                      size="medium"
                      onClick={editGuestHandler}
                    >
                      Edit Guest
                    </Button>
                  ) : (
                    <br />
                  )}
                  {props.GuestDetails.occupancyType == "daily" ||
                  props.GuestDetails.occupancyType == "OneMonth" ? (
                    <Button
                      sx={{ mt: 7, "&.MuiButton-text": { color: "green" } }}
                      color="success"
                      size="medium"
                      onClick={exceedPlan}
                    >
                      Extend Plan{" "}
                    </Button>
                  ) : (
                    <div></div>
                  )}
                  {userData.data.userType !== "manager" ? (
                  <Button
                    sx={{ mt: 7, "&.MuiButton-text": { color: "maroon" } }}
                    color="primary"
                    size="medium"
                    onClick={editBedtHandler}
                  >
                    Change Bed
                  </Button>
                  ) : (
                    <></>
                  )}
                  {(
                  <Button
                    sx={{ mt: 7, "&.MuiButton-text": { color: "maroon" } }}
                    color="primary"
                    size="medium"
                    onClick={extendPlanforRegulatAndMonthlyAsDaily}
                  >
                    ExtendPlanAsDaily
                  </Button>
                  )}
                   {userData.data.userType == "manager" ? (
                  <Button
                    sx={{ mt: 7, "&.MuiButton-text": { color: "#00AACC" } }}
                    color="primary"
                    size="medium"
                  >
                    No Actions
                  </Button>
                  ) : (
                    <></>
                  )}
                  {
                    props.GuestDetails.occupancyType == "OneMonth" || props.GuestDetails.guestStatus === "InNotice" ?
                    (
                      <Button
                      sx={{ mt: 7, "&.MuiButton-text": { color: "orange" } }}
                      color="primary"
                      size="medium"
                      onClick={preBooking}
                    >
                      PreBook
                    </Button>
                    ):(<></>)
                  }

                  {userData.data.userType !== "manager" ? (
                    <Button
                      sx={{ mt: 7, "&.MuiButton-text": { color: "#00AACC" } }}
                      color="success"
                      size="medium"
                      onClick={editDue}
                    >
                      Edit DueAmount
                    </Button>
                  ) : (
                    <></>
                  )}

                  {props.GuestDetails.guestStatus === "InNotice" ? (
                    <Button
                      sx={{ mt: 7, "&.MuiButton-text": { color: "red" } }}
                      color="warning"
                      size="medium"
                      onClick={cancelCheckOut}
                    >
                      Cancel Checkout
                    </Button>
                  ) : null}
                </Stack>
              </Paper>
            </Grid>
          )}

          <Paper sx={{ mt: 2 }}>
            <CheckOut
              func={func}
              open={open}
              guestdetails={props.GuestDetails}
              GuestDueAmount={props.GuestDueAmount}
              handleCloseGuestModalWindow={handleCloseGuestModalWindow}
            />
          </Paper>

          <br />

          <br />

          <h3 className="head-1-checkOut">Transaction History</h3>

          <br />

          <TransactionHistory guestdetails={props.GuestDetails} />
        </DialogContent>

        <DialogActions>
          <Grid container style={{ display: "flex" }}>
            <Grid item xs={6}>
              <MDButton
                width="20%"
                variant="contained"
                color="info"
                size="large"
                justify="center"
                style={{ borderRadius: 10 }}
                onClick={handleCloseGuestModalWindow}
              >
                Close
              </MDButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
